import Vue from 'vue';
import Router from 'vue-router';
import Config from '../../config';
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
import checkRouter from '@/router/check';
// 小站sprint19_V1改版后停用
// const manageOrderFlow = () => import('@/view/manage-order-flow'); // 订单跟进
// const stockSearch = () => import('@/view/stock-search'); // 库存查询
// const stockDetails = () => import('@/view/stock-details'); // 库存详情
// const stockWaitin = () => import('@/view/stock-waitin'); // 待入库
// const stockWaitinDetails = () => import('@/view/stock-waitin-details'); // 待入库详情
// const stockSuccess = () => import('@/view/stock-success'); // 入库成功
// const outStockCreateOrder = () => import('@/view/out-stock-create-order'); // 创建出库单
// const outStockCreate = () => import('@/view/out-stock-create'); // 选择库存并创建
// const outStockOrderlist = () => import('@/view/out-stock-orderlist'); // 出库单

const outStockBatchCreateDetails = () => import('@/view/out-stock-batch-order'); // 合并出库

const outStockCreateDetails = () => import('@/view/out-stock-create-details'); // 创建出库单

const outStockDetail = () => import('@/view/out-stock-detail'); // 出库单详情

const manageOrder = () => import('@/view/manage-order'); // 经营-订单

const manageStock = () => import('@/view/manage-stock'); // 经营-库存
const manageStockHistory = () => import('@/view/manage-stock-history'); // 经营-库存

const manageData = () => import('@/view/manage-data'); // 经营-数据
const newPeopleList = () => import('@/view/manage-data-newPeopleList'); // 拉新榜单

const storeManage = () => import('@/view/store-manage'); // 店铺管理
const storeDetails = () => import('@/view/store-details'); // 店铺详情

const employeesManage = () => import('@/view/employees-manage'); // 店员管理
const employeesDetails = () => import('@/view/employees-details'); // 店员详情
const notFoundComponent = () => import('@/view/404'); // 404

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base:
    process.env.NODE_ENV === 'development'
      ? '/'
      : `${Config.baseUrl_production}`,
  routes: [
    {
      path: '*',
      name: '404',
      meta: {
        keepAlive: false,
        showHeader: true,
        pageTitle: '404'
      },
      component: notFoundComponent
    },
    {
      path: '/',
      redirect: '/manage-order'
    },
    {
      path: '/manage-order',
      name: 'manageOrder',
      meta: {
        keepAlive: false,
        showHeader: false,
        pageTitle: '订单'
      },
      component: manageOrder
    },
    {
      path: '/manage-stock',
      name: 'manageStock',
      meta: {
        keepAlive: false,
        showHeader: false,
        pageTitle: '库存'
      },
      component: manageStock
    },
    {
      path: '/manage-stock-history',
      name: 'manageStockHistory',
      meta: {
        keepAlive: false,
        showHeader: false,
        pageTitle: '库存'
      },
      component: manageStockHistory
    },
    {
      path: '/search',
      name: 'search',
      meta: {
        keepAlive: false,
        showHeader: false,
        pageTitle: '搜索'
      },
      component: () => import('@/view/search')
    },
    {
      path: '/search-list',
      name: 'searchList',
      meta: {
        keepAlive: false,
        showHeader: false,
        pageTitle: '搜索详情'
      },
      component: () => import('@/view/search-list')
    },
    {
      path: '/order-filter',
      name: 'orderFilter',
      meta: {
        keepAlive: false,
        showHeader: false,
        pageTitle: '订单筛选'
      },
      component: () => import('@/view/order-filter')
    },
    {
      path: '/manage-data',
      name: 'manageData',
      meta: {
        keepAlive: false,
        showHeader: true,
        pageTitle: '数据中心'
      },
      component: manageData
    },
    {
      path: '/manage-data-newPeopleList',
      name: 'manage-data-newPeopleLis',
      meta: {
        keepAlive: false,
        showHeader: true,
        pageTitle: '拉新战神榜'
      },
      component: newPeopleList
    },
    // {
    //   path: '/manage-order-flow',
    //   name: 'manageOrderFlow',
    //   meta: {
    //     keepAlive: false,
    //     showHeader: true,
    //     pageTitle: '跟进信息填写'
    //   },
    //   component: manageOrderFlow
    // },
    // {
    //   path: '/stock-search',
    //   name: 'stockSearch',
    //   meta: {
    //     keepAlive: false,
    //     showHeader: true,
    //     pageTitle: '库存查询'
    //   },
    //   component: stockSearch
    // },
    // {
    //   path: '/stock-details',
    //   name: 'stockDetails',
    //   meta: {
    //     keepAlive: false,
    //     showHeader: true,
    //     pageTitle: '库存详情'
    //   },
    //   component: stockDetails
    // },
    // {
    //   path: '/stock-waitin',
    //   name: 'stockWaitin',
    //   meta: {
    //     keepAlive: false,
    //     showHeader: true,
    //     pageTitle: '待入库'
    //   },
    //   component: stockWaitin
    // },
    // {
    //   path: '/stock-waitin-details',
    //   name: 'stockWaitinDetails',
    //   meta: {
    //     keepAlive: false,
    //     showHeader: true,
    //     pageTitle: '待入库详情'
    //   },
    //   component: stockWaitinDetails
    // },
    // {
    //   path: '/stock-success',
    //   name: 'stockSuccess',
    //   meta: {
    //     keepAlive: false,
    //     showHeader: true,
    //     pageTitle: '入库完成'
    //   },
    //   component: stockSuccess
    // },
    // {
    //   path: '/out-stock-create',
    //   name: 'outStockCreate',
    //   meta: {
    //     keepAlive: false,
    //     showHeader: true,
    //     pageTitle: '选择库存并创建'
    //   },
    //   component: outStockCreate
    // },
    // {
    //   path: '/out-stock-create-order',
    //   name: 'outStockCreateOrder',
    //   meta: {
    //     keepAlive: false,
    //     showHeader: true,
    //     pageTitle: '创建出库单'
    //   },
    //   component: outStockCreateOrder
    // },
    {
      path: '/out-stock-batch-order',
      name: 'outStockBatchCreateDetails',
      meta: {
        keepAlive: false,
        showHeader: true,
        pageTitle: '合并出库'
      },
      component: outStockBatchCreateDetails
    },
    {
      path: '/out-stock-create-details',
      name: 'outStockCreateDetails',
      meta: {
        keepAlive: false,
        showHeader: true,
        pageTitle: '创建出库单'
      },
      component: outStockCreateDetails
    },
    {
      path: '/out-stock-detail',
      name: 'outStockDetail',
      meta: {
        keepAlive: false,
        showHeader: true,
        pageTitle: '出库单详情'
      },
      component: outStockDetail
    },
    // {
    //   path: '/out-stock-orderlist',
    //   name: 'outStockOrderlist',
    //   meta: {
    //     keepAlive: false,
    //     showHeader: true,
    //     pageTitle: '出库单'
    //   },
    //   component: outStockOrderlist
    // },
    {
      path: '/store-manage',
      name: 'storeManage',
      meta: {
        keepAlive: false,
        showHeader: true,
        pageTitle: '店铺管理'
      },
      component: storeManage
    },
    {
      path: '/store-details',
      name: 'storeDetails',
      meta: {
        keepAlive: false,
        showHeader: true,
        pageTitle: '店铺详情'
      },
      component: storeDetails
    },
    {
      path: '/employees-manage',
      name: 'employeesManage',
      meta: {
        keepAlive: false,
        showHeader: true,
        pageTitle: '店员管理'
      },
      component: employeesManage
    },
    {
      path: '/employees-details',
      name: 'employeesDetails',
      meta: {
        keepAlive: false,
        showHeader: true,
        pageTitle: '店员信息'
      },
      component: employeesDetails
    },
    {
      path: '/help-center',
      name: 'helpCenter',
      meta: {
        keepAlive: false,
        showHeader: true,
        pageTitle: '帮助中心'
      },
      component: () => import('@/view/help-center')
    },
    {
      path: '/help-center-info',
      name: 'helpCenterInfo',
      meta: {
        keepAlive: false,
        showHeader: true,
        pageTitle: '更新日志'
      },
      component: () => import('@/view/help-center-info')
    },
    {
      path: '/feedback-info',
      name: 'feedbackInfo',
      meta: {
        keepAlive: false,
        showHeader: true,
        pageTitle: '意见反馈'
      },
      component: () => import('@/view/feedback-info')
    },
    {
      path: '/down-app',
      name: 'downApp',
      meta: {
        keepAlive: false,
        showHeader: true,
        pageTitle: 'APP下载'
      },
      component: () => import('@/view/down-app')
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        keepAlive: false,
        showHeader: true,
        pageTitle: '登录'
      },
      component: () => import('@/view/login')
    },
    {
      path: '/coupon-info',
      name: 'couponInfo',
      meta: {
        keepAlive: false,
        showHeader: true,
        pageTitle: '券码信息'
      },
      component: () => import('@/view/coupon-info')
    },
    {
      path: '/quotation-detail',
      name: 'quotationDetail',
      meta: {
        keepAlive: false,
        showHeader: true,
        pageTitle: '查看机型报价'
      },
      component: () => import('@/view/quotation-detail')
    },
    {
      path: '/quoted-price',
      name: 'quotedPrice',
      meta: {
        keepAlive: false,
        showHeader: true,
        pageTitle: '查看报价'
      },
      component: () => import('@/view/quoted-price')
    },
    {
      path: '/quoted-price-search',
      name: 'quotedPriceSearch',
      meta: {
        keepAlive: false,
        showHeader: false
      },
      component: () => import('@/view/quoted-price-search')
    },
    {
      path: '/quot-ad',
      name: 'quotAd',
      meta: {
        keepAlive: false,
        showHeader: false,
        pageTitle: '我要卖'
      },
      component: () => import('@/view/quot-ad')
    },
    {
      path: '/seller-recorded-stock',
      name: 'sellerRecordedStock',
      meta: {
        keepAlive: false,
        showHeader: true,
        pageTitle: '录入库存'
      },
      component: () => import('@/view/seller-recorded-stock')
    },
    {
      path: '/register',
      name: 'register',
      meta: {
        keepAlive: false,
        showHeader: true,
        pageTitle: '用户注册'
      },
      component: () => import('@/view/register')
    },
    {
      path: '/pay',
      name: 'pay',
      meta: {
        keepAlive: false,
        showHeader: true,
        pageTitle: '支付'
      },
      component: () => import('@/view/pay')
    },
    {
      path: '/payResult',
      name: 'payResult',
      meta: {
        keepAlive: false,
        showHeader: true,
        pageTitle: '支付结果'
      },
      component: () => import('@/view/pay-result')
    },
    {
      path: '/agreement',
      name: 'agreement',
      meta: {
        keepAlive: false,
        showHeader: true,
        pageTitle: '协议'
      },
      component: () => import('@/view/agreement')
    },
    {
      path: '/order-calendar',
      name: 'order-calendar',
      meta: {
        keepAlive: false,
        pageTitle: '接单日历'
      },
      component: () => import('@/view/order-calendar')
    },
    {
      path: '/to-apply-visitor',
      name: 'to-apply-visitor',
      meta: {
        keepAlive: false,
        pageTitle: '去申请上门'
      },
      component: () => import('@/view/to-apply-visitor')
    },
    {
      path: '/apply-visitor',
      name: 'apply-visitor',
      meta: {
        keepAlive: false,
        pageTitle: '申请上门'
      },
      component: () => import('@/view/apply-visitor')
    },
    {
      path: '/real-name-auth',
      name: 'real-name-auth',
      meta: {
        keepAlive: false,
        pageTitle: '实名认证'
      },
      component: () => import('@/view/real-name-auth')
    },
    {
      path: '/share',
      name: 'share',
      meta: {
        keepAlive: false,
        pageTitle: '邀请好友'
      },
      component: () => import('@/view/activity/share')
    },
    {
      path: '/share-down',
      name: 'share-down',
      meta: {
        keepAlive: false,
        pageTitle: '加入上门工程师'
      },
      component: () => import('@/view/activity/share-down')
    },
    {
      path: '/credit-recycle-info',
      name: 'credit-recycle-info',
      meta: {
        keepAlive: false,
        pageTitle: '信用回收说明'
      },
      component: () => import('@/view/credit-recycle-info')
    },
    {
      path: '/report',
      name: 'report',
      meta: {
        keepAlive: false,
        pageTitle: '专业检测报告'
      },
      component: () => import('@/view/report')
    },
    {
      path: '/device-detail',
      name: 'deviceDetail',
      meta: {
        keepAlive: false,
        pageTitle: '验机详情'
      },
      component: () => import('@/view/device-detail')
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  // 小站sprint19_V1改版后停用
  // if (Vue.$chart) {
  //   Vue.$chart.reSetCurColorIndex();
  // }
  const userRes = await checkRouter.loginUser(to);
  if (!userRes) return false;
  const roleRes = checkRouter.roleAuth(to);
  if (!roleRes) {
    next({ path: '/to-apply-visitor', query: to.query });
    return false;
  }
  next();
});

export default router;
